export enum ADD_TO_HOMESCREEN_EVENT_DATA {
  moduleName = 'add to homescreen banner',
  flow = 'add widget to homescreen',
}
